// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pdf {\n  top: 0;\n  width: 80%;\n  margin-left: 10%;\n  z-index: 1000;\n}\n", ""]);
// Exports
module.exports = exports;
